<template>
  <div id="container">
    <div class="box-content-title">
      <div class="title-font-style">
        <span>团队特价审批记录</span>
      </div>
    </div>
    <el-form class="search-style">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item>
            <el-select v-model="queryParams.column" @change="onChangeColumn">
              <el-option
                v-for="(item,index) in teamSpecialOfferApproveRecord"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-select v-model="queryParams.value" v-if="queryParams.column==='state'">
              <el-option
                v-for="(item, i) in stateList"
                :key="i"
                :label="item.lab"
                :value="item.val"
              ></el-option>
            </el-select>
            <el-date-picker
              style="width:100%"
              value-format="yyyy-MM-dd HH:mm"
              v-else-if="queryParams.column==='processDate' || queryParams.column==='createDate'"
              v-model="time"
              :default-time="['00:00:00','23:59:59']"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <el-input v-else v-model="queryParams.value" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="box-table" :style="{height: $store.state.Sell.heightTitle+'px'}">
      <el-table
        border
        ref="tableRef"
        :data="list"
        :max-height="$store.state.Sell.heightTitle"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column fixed label="客户名称" show-overflow-tooltip width="120px">
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="toCusName(scope.row)"
            >{{scope.row.cusName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
        <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
        <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column label="型号" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onProductDetail(scope.row)"
            >{{scope.row.proModel}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="proOrdernum" label="订货号" show-overflow-tooltip></el-table-column>
        <el-table-column label="审批特价">
          <template slot-scope="scope">{{scope.row.specialPrice|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="折扣">
          <template slot-scope="scope">{{scope.row.proDiscount|perCentFilter}}</template>
        </el-table-column>
        <el-table-column label="产品面价">
          <template slot-scope="scope">{{scope.row.proPrice|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="审批状态">
          <template slot-scope="scope">{{scope.row.state===4?'已通过':scope.row.state===3?'已驳回':'审批中'}}</template>
        </el-table-column>
        <el-table-column label="价格有效期" width="125">
          <template slot-scope="scope">{{scope.row.specialDate|dateFilterL}}</template>
        </el-table-column>
        <el-table-column label="是否开启">
          <template slot-scope="scope">{{scope.row.flag?'开启':'关闭'}}</template>
        </el-table-column>
        <el-table-column prop="cspaMark" label="申请原因" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createUser" label="发起人"></el-table-column>
        <el-table-column prop="orgName" label="所属部门"></el-table-column>
        <el-table-column label="发起时间" width="125">
          <template slot-scope="scope">{{scope.row.createDate|dateFilterL}}</template>
        </el-table-column>
        <el-table-column prop="processUser" label="处理人"></el-table-column>
        <el-table-column label="处理时间" width="125">
          <template slot-scope="scope">{{scope.row.processDate|dateFilterL}}</template>
        </el-table-column>
        <el-table-column prop label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button @click="onClose(scope.row)" type="text" v-if="scope.row.flag">关闭特价</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
    <open-or-close
      @onUpdataState="onUpdataState"
      content="是否确定关闭特价？"
      title="关闭特价"
      ref="openOrCloseRefs"
    ></open-or-close>
  </div>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import pagination from '@/components/pagination'
import { queryPageAllByTeam, updateByFlag } from '@/api/sell/sellManage'
import { teamSpecialOfferApproveRecord } from './util/data'
export default {
  components: { pagination, OpenOrClose },
  data () {
    return {
      id: '',
      queryParams: {
        column: 'cusName'
      },
      time: [],
      teamSpecialOfferApproveRecord,
      stateList: [
        { lab: '审批通过', val: 4 },
        { lab: '审批中', val: 1 },
        { lab: '审批不通过', val: 3 }
      ],
      columnArr: [],
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  watch: {
    queryParams (val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'cusName')
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    toCusName (row) {
      this.$router.push({ name: 'customer/details', query: { id: row.cusId } })
    },
    onProductDetail (row) {
      this.$router.push({ name: 'productDetails', query: { id: row.proId } })
    },
    onUpdataState () {
      updateByFlag(this.id).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('关闭特价成功!')
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onClose (row) {
      this.id = row.id
      this.$refs.openOrCloseRefs.onInitial()
    },
    onChangeColumn (val) {
      this.time = []
      this.queryParams = {}
      this.queryParams.column = val
    },
    onSearch () {
      // 搜索
      if (this.time.length === 2) {
        this.queryParams.value = this.time[0]
        this.queryParams.endValue = this.time[1]
      }
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.columnArr = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    onReset () {
      this.columnArr = []
      this.queryParams = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    getList () {
      this.loadingTable = true
      const obj = {
        criteriaVoList: [...this.columnArr],
        queryPageName: ''
      }
      queryPageAllByTeam(this.currentPage, this.pageSize, obj).then((res) => {
        if (res.data.code === 200) {
          this.loadingTable = false
          this.list = res.data.obj.records
          this.total = res.data.obj.total
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
